import { useSupportsWebp } from '../contexts/DeviceContext';

export default function useFormatImageUrl() {
    const supportsWebp = useSupportsWebp();
    return (url: string | null) => {
        if (url === null) {
            return null;
        }
        if (
            supportsWebp &&
            url.match(/images\.urbania\.(ca|fr)/) !== null &&
            url.match(/\.webp$/) === null &&
            url.match(/\.svg$/) === null &&
            url.match(/\.gif$/) === null
        ) {
            return `${url}.webp`;
        }
        return url;
    };
}
